/**
 * SEO cannibalization: sekundära produktsidor pekar till primär landning
 * för huvudqueryn (inte generisk "optimera SEO").
 *
 * Bred “hyra tross” → /scen (interim). Längd-/komponentsidor behåller
 * produktspecifik relevans men länkar uppåt för komplett lösning.
 */

export type ProductCannibalizationHint = {
  /** Primär URL som ska äga sökfrasen */
  primaryPath: string;
  primaryLabel: string;
  /** Kort förklaring till besökaren */
  message: string;
};

const SCEN_TROSS_HINT: ProductCannibalizationHint = {
  primaryPath: '/scen',
  primaryLabel: 'Hyra scen & tross – komplett lösning',
  message:
    'Behöver du komplett scen- eller trosslösning (flera längder, hörn, rigg, offert)? Börja på scensidan. Denna sida är en specifik trosskomponent.',
};

/** slug → hint (visas på sekundära sidor) */
export const PRODUCT_CANNIBALIZATION_HINTS: Record<string, ProductCannibalizationHint> = {
  'tross-0-25-m': SCEN_TROSS_HINT,
  'tross-0-5-m': {
    ...SCEN_TROSS_HINT,
    message:
      'Behöver du hyra tross till event generellt? Börja med komplett scen-/trosslösning. Denna sida är den korta 0,5 m-sektionen.',
  },
  'tross-0-75-m': SCEN_TROSS_HINT,
  'tross-1-meter': SCEN_TROSS_HINT,
  'tross-2-meter': {
    ...SCEN_TROSS_HINT,
    message:
      'Behöver du komplett scen- eller trossystem (flera längder, hörn, offert)? Se scensidan. Denna sida är 2-meterssektionen.',
  },
  'tross-3-meter': SCEN_TROSS_HINT,
  'tross-90-grader': SCEN_TROSS_HINT,
  'tross-t-horn': SCEN_TROSS_HINT,
  'trevags-tross': {
    ...SCEN_TROSS_HINT,
    message:
      'Trevägs-tross är ett specialkoppel. För vanlig hyra tross / komplett lösning till event, börja på scensidan.',
  },
  'basplatta-till-tross': SCEN_TROSS_HINT,
  'scenpodie-2x1-m': {
    primaryPath: '/produkter/scenpodie-1x0-5-m',
    primaryLabel: 'Scenpodie 1×0,5 m',
    message:
      'Större scenpodie 2×1 m. För den vanligaste scenpodie-storleken, se 1×0,5 m som primärt val.',
  },
  'lilla-studentflaket': {
    primaryPath: '/student',
    primaryLabel: 'Studentflak – priser & paket',
    message:
      'Jämför studentflak pris och paket på studenthubben. Den här produktsidan är ett specifikt paket.',
  },
};

export function getProductCannibalizationHint(
  slug: string | undefined,
): ProductCannibalizationHint | null {
  if (!slug) return null;
  return PRODUCT_CANNIBALIZATION_HINTS[slug] ?? null;
}
